// @ts-nocheck
import React from 'react';
import WorkGallery from '../../components/WorkGallery';

// The signed-in student's own gallery: published task files, their submissions.
export default function StudentWorkGallery() {
  return (
    <div style={{ padding: 24, display: 'grid', gap: 16 }}>
      <header>
        <h1 style={{ margin: 0, color: '#1e3a5f', fontSize: 24 }}>My Work Gallery</h1>
        <p style={{ margin: '6px 0 0', color: '#64748b', fontSize: 14, lineHeight: 1.6 }}>
          Everything in one place: materials your teachers published to you and the work you submitted.
        </p>
      </header>
      <WorkGallery studentId="me" heading="My work" />
    </div>
  );
}
